import React from 'react';
//@ts-ignore
import { Loader } from '@front/ui-uchi';
import { Wrapper } from './elements';

const LoaderComponent = ({ color = '#DCECFF' }: { color?: string }) => {
	return (
		<Wrapper>
			<Loader color={color} size="1em" />
		</Wrapper>
	);
};

export default LoaderComponent;
